import actions from '../../actions/LifeBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Life', actions.show.main, actions.show.reset)
